import { all, takeLatest, call, put } from "redux-saga/effects";
import { bookOfferRequest, bookOfferSuccess, bookOfferFailure } from "./actions";
import bookingService from '../../services/bookingService';

const getBookingErrorMessage = (error) => {
  const backendMessage = error?.response?.data?.error?.message
    || error?.response?.data?.message
    || error?.response?.data?.detail
    || error?.message;

  return backendMessage || 'Booking failed.';
};

export function* bookOfferSaga({ payload }) {
  try {
    const data = yield call(bookingService.submitBooking, payload);
    yield put(bookOfferSuccess(data));
    // Note: Sagas don't return data to the dispatch call
  } catch (error) {
    yield put(bookOfferFailure(getBookingErrorMessage(error)));
  }
}

export default function* bookingSaga() {
  yield all([takeLatest(bookOfferRequest, bookOfferSaga)]);
}